import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// To load the translation files
import Backend from 'i18next-xhr-backend';

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('lng', lng);
});

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    ns: ['translations'], // Names of the translation files
    defaultNS: 'translations',
    backend: {
      loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`, // Path to the translation files
    },
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'lng',
    },
  });

export default i18n;
